import React from 'react';
import styles from '../SettingsManager.module.scss';
import { AppSettings } from '../../../types';
import { CLOCK_THEMES } from '../../../styles/clockThemes';

interface ThemeColors {
  textColor: string;
  accentColor: string;
  secondaryText: string;
}

interface ClockStyleSelectorProps {
  settings: AppSettings;
  onSettingsChange: (settings: AppSettings) => void;
  themeColors?: ThemeColors;
}

export const ClockStyleSelector: React.FC<ClockStyleSelectorProps> = ({ settings, onSettingsChange, themeColors }) => {
  const handleThemeChange = (themeId: string) => {
    onSettingsChange({
      ...settings,
      clockThemeId: themeId
    });
  };

  const labelStyle: React.CSSProperties = themeColors ? {
    color: themeColors.textColor
  } : {};

  const getButtonStyle = (isActive: boolean): React.CSSProperties => {
    if (!themeColors) return {};
    return {
      borderColor: isActive ? themeColors.accentColor : 'rgba(0,0,0,0.1)',
      backgroundColor: isActive ? `${themeColors.accentColor}15` : 'transparent'
    };
  };

  const nameStyle: React.CSSProperties = themeColors ? {
    color: themeColors.textColor
  } : {};

  const descStyle: React.CSSProperties = themeColors ? {
    color: themeColors.secondaryText
  } : {};

  return (
    <div className={styles.section}>
      <label className={styles.label} style={labelStyle}>
        Clock Style:
      </label>
      <div className={styles.grid}>
        {Object.values(CLOCK_THEMES).map(theme => (
          <button
            key={theme.id}
            onClick={() => handleThemeChange(theme.id)}
            className={`${styles.themeButton} ${settings.clockThemeId === theme.id ? styles.active : ''}`}
            style={getButtonStyle(settings.clockThemeId === theme.id)}
          >
            <div className={styles.themeName} style={nameStyle}>{theme.name}</div>
            <div className={styles.themeDesc} style={descStyle}>{theme.description}</div>
          </button>
        ))}
      </div>
    </div>
  );
};
